var React = require('react');
var createReactClass = require('create-react-class');
var Helmet = require('react-helmet');

var PostContainerHelmet = createReactClass({

	getMetaTitle: function(){
		return (this.props.postContainer.fields.postMeta && this.props.postContainer.fields.postMeta.fields.title) || this.props.postContainer.fields.title;
	},

	getMetaDescription: function(){
		return (this.props.postContainer.fields.postMeta && this.props.postContainer.fields.postMeta.fields.description) || '';
	},

	getMetas: function(){
		var metas = [
			{"property": "og:title", "content": this.getMetaTitle() + ' | MyGiHealth'},
			{"property": "article:section", "content": this.props.postContainer.fields.category.fields.name},
			{"property": "article:published_time", "content": this.props.postContainer.fields.publishedDate}
		];

		var metaDescription = this.getMetaDescription();

		if(metaDescription !== ''){
			metas.push({"property": "og:description", "content": metaDescription});
		}

		return metas;
	},

	render: function () {
        return (
            <Helmet
                title={this.getMetaTitle()}
                meta={this.getMetas()}
            />
        );
    }
});

module.exports = PostContainerHelmet;



// WEBPACK FOOTER //
// ./src/common/routes/posts/components/layout/postContainerHelmet.jsx